export default {
  light: {
    primary: 'rgb(253, 255, 252)',
    secondary: 'rgb(8, 9, 9)',
    secondary60: 'rgba(8, 9, 9,0.6)',
  },
  dark: {
    primary: 'rgb(8, 9, 9)',
    secondary: 'rgb(253, 255, 252)',
    secondary60: 'rgba(253, 255, 252, 0.6)',
  },
};
